<template>
  <div style="width: 100%">
    <!-- Pesquisar -->
    <v-row
      class="justify-end"
      dense
    >
      <v-tooltip top>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn
            color="primary"
            @click="pesquisar"
            v-on="{ ...onTooltip }"
          >
            Pesquisar
          </v-btn>
        </template>
        <span>Clique para pesquisar</span>
      </v-tooltip>
    </v-row>

    <!-- Participação -->
    <v-card
      v-if="relatorio"
      flat
      class="mx-4"
    >
      <!-- Gráficos -->
      <v-row>
        <v-col cols="12">
          <app-title texto="GRÁFICOS" />
        </v-col>
        <v-col cols="12">
          <gauge-chart
            :dados="dadosGauge"
            :fonte="`Fonte: Sistema Desenvolva, ${anoAtual}`"
            :maximo="100"
            :minimo="0"
            :titulo="`Participação Geral do Perfil`"
            class="chart"
            descricao="Percentual de Conclusão da(s) Unidade(s)"
            descricao-titulo="Participação Geral do Perfil"
            formato="%"
            :is-get-svg="isGetSvg"
            @svg="(value) => svg = value"
          />
        </v-col>

        <!-- Quadro Resumo -->
        <v-col cols="12">
          <v-data-table
            :headers="tabelaUnidades.headers"
            :items="relatorio.unidades"
            class="elevation-0"
            :search="opcoesQuadroResumo.pesquisa"
            :custom-filter="customFilterUnidades"
            :sort-by="opcoesQuadroResumo.ordenarPor"
            :sort-desc="opcoesQuadroResumo.decrescente"
          >
            <!-- título, ordenar por, pesquisar -->
            <template v-slot:top>
              <!-- título -->
              <v-row class="mb-2">
                <v-toolbar flat>
                  <v-toolbar-title>
                    <h2 class="title primary--text text--darken-1 text-no-wrap">
                      PARTICIPAÇÃO GERAL DO PERFIL
                    </h2>
                  </v-toolbar-title>
                </v-toolbar>
              </v-row>
              <v-row>
                <!-- ordenar por -->
                <v-col
                  cols="12"
                  md="4"
                >
                  <app-sort v-model="opcoesQuadroResumo" />
                </v-col>
                <v-spacer />

                <!-- pesquisar -->
                <v-col
                  cols="12"
                  md="4"
                >
                  <app-search v-model="opcoesQuadroResumo" />
                </v-col>
              </v-row>
            </template>

            <!-- coluna Percentual de conclusão da unidade -->
            <template v-slot:[`item.percentualConclusao`]="{ item }">
              {{ calcularPctStr(item.percentualConclusao) }}
            </template>

            <!-- total -->
            <template v-slot:[`body.append`]>
              <tr>
                <td align="center" colspan="2">
                  <strong class="subtitle-2 grey--text text--darken-2">TOTAL</strong>
                </td>
                <td align="center"><strong>{{ total.servidores }}</strong></td>
                <td align="center"><strong>{{ total.pendentes }}</strong></td>
                <td align="center"><strong>{{ total.concluidos }}</strong></td>
                <td align="center"><strong>{{ total.percentual | decimal }} %</strong></td>
              </tr>
            </template>
          </v-data-table>
        </v-col>

        <!-- Resultados -->
        <v-col cols="12">
          <v-data-table
            :headers="tabelaResultados.headers"
            :items="relatorio.servidores"
            class="elevation-0"
            :search="opcoesResultados.pesquisa"
            :custom-filter="customFilterServidores"
            :sort-by="opcoesResultados.ordenarPor"
            :sort-desc="opcoesResultados.decrescente"
          >
            <!-- título, ordenar por, pesquisar -->
            <template v-slot:top>
              <!-- título -->
              <v-row class="mb-2">
                <v-toolbar flat>
                  <v-toolbar-title>
                    <h2 class="title primary--text text--darken-1 text-no-wrap">
                      RESULTADOS
                    </h2>
                  </v-toolbar-title>
                </v-toolbar>
              </v-row>
              <v-row>
                <!-- ordenar por -->
                <v-col
                  cols="12"
                  md="4"
                >
                  <app-sort v-model="opcoesResultados" />
                </v-col>
                <v-spacer />
                <!-- pesquisar -->
                <v-col
                  cols="12"
                  md="4"
                >
                  <app-search v-model="opcoesResultados" />
                </v-col>
              </v-row>
            </template>

            <!-- Cadastro -->
            <template v-slot:[`item.cadastro`]="{ item }">
              <v-icon color="grey">
                {{ `${getIcone(item.isCadastroOk)}` }}
              </v-icon>
            </template>
            <!-- Formação -->
            <template v-slot:[`item.formacao`]="{ item }">
              <v-icon color="grey">
                {{ `${getIcone(item.isFormacaoOk)}` }}
              </v-icon>
            </template>
            <!-- Atuação Profissional -->
            <template v-slot:[`item.atuacaoProfissional`]="{ item }">
              <v-icon color="grey">
                {{ `${getIcone(item.isAtuacaoProfissionalOk)}` }}
              </v-icon>
            </template>
            <!-- Atividades de Interesses -->
            <template v-slot:[`item.atividadesInteresse`]="{ item }">
              <v-icon color="grey">
                {{ `${getIcone(item.isAtividadesDeInteresseOk)}` }}
              </v-icon>
            </template>
            <!-- Preferências de Trabalho -->
            <template v-slot:[`item.preferenciasTrabalho`]="{ item }">
              <v-icon color="grey">
                {{ `${getIcone(item.isPreferenciasDeTrabalhoOk)}` }}
              </v-icon>
            </template>
            <!-- Situação -->
            <template v-slot:[`item.situacao`]="{ item }">
              {{ item.isConcluido ? "CONCLUÍDO" : "PENDENTE" }}
            </template>
          </v-data-table>
        </v-col>
      </v-row>

      <!-- Relatório PDF -->
      <v-row
        class="justify-end mb-1"
      >
        <v-tooltip
          max-width="400"
          top
        >
          <template v-slot:activator="{ on }">
            <v-btn
              color="success"
              @click="getRelatorio()"
              v-on="on"
            >
              <v-icon>get_app</v-icon>
              BAIXAR PDF
            </v-btn>
          </template>
          <span>Clique para baixar o relatório dos dados em formato PDF.</span>
        </v-tooltip>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { sum } from 'mathjs';
import Data from '@/modules/data';
import { pesquisar } from '@/modules/texto';
import { generatePDF, preparePdf, convertSvg } from '@/modules/relatorioPDF';
import AppTitle from '@/components/core/AppTitle';
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';
import GaugeChart from '@/components/chart/GaugeChart';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import toDecimal from '@/filters/decimal';

const monitoramentoRepository = RepositoryFactory.get('monitoramento');

export default {
  name: 'RelatorioPerfilParticipacao',

  components: {
    AppTitle,
    GaugeChart,
    AppSort,
    AppSearch,
  },

  props: {
    selecaoUnidade: {
      type: Object,
      default: () => ({
        macro: false,
        unidades: [],
        categoria: 'TODOS',
      }),
      required: true,
    },
  },

  data() {
    return {
      relatorio: null,
      tabelaUnidades: {
        headers: [
          {
            text: 'NOME DA UNIDADE',
            value: 'nome',
            width: '40%',
            sortable: false,
          },
          {
            text: 'SIGLA DA UNIDADE',
            value: 'sigla',
            width: '10%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'TOTAL DE SERVIDORES',
            value: 'totalServidores',
            width: '10%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'PENDENTES',
            value: 'totalPendentes',
            width: '10%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'CONCLUÍDOS',
            value: 'totalConcluidos',
            width: '10%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'PERCENTUAL DE CONCLUSÃO DA UNIDADE',
            value: 'percentualConclusao',
            width: '20%',
            sortable: false,
            align: 'center',
          },
        ],
      },
      tabelaResultados: {
        headers: [
          { text: 'SERVIDOR', value: 'nome', sortable: false },
          {
            text: 'UNIDADE',
            value: 'siglaUnidade',
            width: '10%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'CADASTRO',
            value: 'cadastro',
            width: '10%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'FORMAÇÃO',
            value: 'formacao',
            width: '10%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'ATUAÇÃO PROFISSIONAL',
            value: 'atuacaoProfissional',
            width: '10%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'ATIVIDADES DE INTERESSE',
            value: 'atividadesInteresse',
            width: '10%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'PREFERÊNCIAS DE TRABALHO',
            value: 'preferenciasTrabalho',
            width: '10%',
            sortable: false,
            align: 'center',
          },
          {
            text: 'SITUAÇÃO',
            value: 'situacao',
            width: '15%',
            sortable: false,
            align: 'center',
          },
        ],
      },
      opcoesQuadroResumo: {
        pesquisa: '',
        decrescente: false,
        ordenarPor: 'nome',
        selecionado: { id: 'nome', descricao: 'Nome da Unidade' },
        lista: [
          { id: 'nome', descricao: 'Nome da Unidade' },
          { id: 'sigla', descricao: 'Sigla da Unidade' },
          { id: 'totalServidores', descricao: 'Total de Servidores' },
          { id: 'totalPendentes', descricao: 'Pendentes' },
          { id: 'totalConcluidos', descricao: 'Concluídos' },
          { id: 'percentualConclusao', descricao: 'Percentual de conclusão da Unidade' },
        ],
      },
      opcoesResultados: {
        pesquisa: '',
        decrescente: false,
        ordenarPor: 'nome',
        selecionado: { id: 'nome', descricao: 'Nome do Servidor' },
        lista: [
          { id: 'nome', descricao: 'Nome do Servidor' },
          { id: 'siglaUnidade', descricao: 'Sigla da Unidade' },
          { id: 'isCadastroOk', descricao: 'Cadastro' },
          { id: 'isFormacaoOk', descricao: 'Formação' },
          { id: 'isAtuacaoProfissionalOk', descricao: 'Atuação Profissional' },
          { id: 'isAtividadesDeInteresseOk', descricao: 'Atividades de Interesse' },
          { id: 'isPreferenciasDeTrabalhoOk', descricao: 'Preferências de Trabalho' },
          { id: 'isConcluido', descricao: 'Situação' },
        ],
      },
      isGetSvg: false,
      svg: null,
    };
  },

  computed: {
    payload() {
      return {
        isMacro: this.selecaoUnidade.macro,
        categoria: this.selecaoUnidade.categoria,
        unidades: this.selecaoUnidade.unidades.map((u) => ({ id: u.id })),
      };
    },
    dadosGauge() {
      return [parseFloat(this.relatorio.percentualConclusao) * 100];
    },
    anoAtual() {
      return Data.get().year();
    },
    total() {
      const total = {
        servidores: 0,
        pendentes: 0,
        concluidos: 0,
        percentual: 0.0,
      };

      if (this.relatorio) {
        total.servidores = sum(this.relatorio.unidades.map((u) => u.totalServidores));
        total.pendentes = sum(this.relatorio.unidades.map((u) => u.totalPendentes));
        total.concluidos = sum(this.relatorio.unidades.map((u) => u.totalConcluidos));
        total.percentual = (total.concluidos / total.servidores) * 100;
      }

      return total;
    },
  },

  methods: {
    pesquisar() {
      if (this.selecaoUnidade.unidades.length > 0) {
        monitoramentoRepository.getDadosPerfil(this.payload).then((response) => {
          this.relatorio = response.data;
          this.$store.dispatch('app/success', { response, message: '' });
        });
      } else {
        this.$store.dispatch('app/showMessage', {
          cor: 'warning',
          texto: 'É necessário selecionar, pelo menos, uma unidade!',
        });
      }
    },
    calcularPctStr(pct) {
      if (pct !== null) {
        pct *= 100;
        return `${pct.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}%`;
      }
      return 'NÃO SE APLICA';
    },
    getIcone(participacaoOk) {
      return participacaoOk ? 'check_box' : 'check_box_outline_blank';
    },
    customFilterUnidades(value, search, item) {
      return pesquisar(item.nome, search) || pesquisar(item.sigla, search);
    },
    customFilterServidores(value, search, item) {
      return (
        pesquisar(item.nome, search)
        || pesquisar(item.siglaUnidade, search)
        || (item.isConcluido && pesquisar('concluido', search))
        || (!item.isConcluido && pesquisar('pendente', search))
      );
    },
    async getRelatorio() {
      this.isGetSvg = true;
      await preparePdf(async () => {
        const documento = {
          nome: 'relatorio-participacao-geral-perfil',
          orientacao: 'landscape',
          cabecalho: {
            titulo: 'Relatório de Participação Geral do Perfil',
            itens: [
              `Unidade(s): ${this.relatorio.unidades.map((u) => u.sigla).join(', ')}`,
            ],
          },
          blocos: [
            {
              titulo: 'GRÁFICOS',
              subtitulo: 'UNIDADES',
              itens: [{ tipo: 'imagem', valor: await convertSvg(this.svg), largura: 140 }],
            },
            {
              titulo: 'QUADRO RESUMO',
              subtitulo: 'UNIDADES',
              itens: [{
                tipo: 'tabela',
                valor: {
                  colunas: [
                    'UNIDADE',
                    'SIGLA',
                    'SERVIDORES',
                    'PENDENTES',
                    'CONCLUÍDOS',
                    'PERCENTUAL\nDE CONCLUSÃO',
                  ],
                  linhas: this.relatorio.unidades.map((u) => ([
                    u.nome,
                    u.sigla,
                    u.totalServidores,
                    u.totalPendentes,
                    u.totalConcluidos,
                    `${toDecimal(u.percentualConclusao * 100)}%`,
                  ])),
                },
              }],
            },
            {
              titulo: 'RESULTADOS',
              subtitulo: 'SERVIDORES',
              itens: [{
                tipo: 'tabela',
                valor: {
                  colunas: [
                    'SERVIDOR',
                    'UNIDADE',
                    'CADASTRO',
                    'FORMAÇÃO',
                    'ATUAÇÃO\nPROFIS-\nSIONAL',
                    'ATIVIDADES\nDE\nINTERESSE',
                    'PREFERÊN-\nCIAS DE\nTRABALHO',
                    'SITUAÇÃO',
                  ],
                  linhas: this.relatorio.servidores.map((s) => ([
                    s.nome,
                    s.siglaUnidade,
                    this.getIsConcluido(s.isCadastroOk),
                    this.getIsConcluido(s.isFormacaoOk),
                    this.getIsConcluido(s.isAtuacaoProfissionalOk),
                    this.getIsConcluido(s.isAtividadesDeInteresseOk),
                    this.getIsConcluido(s.isPreferenciasDeTrabalhoOk),
                    s.isConcluido ? 'CONCLUÍDO' : 'PENDENTE',
                  ])),
                },
              }],
            },
          ],
        };
        generatePDF(documento);
      });
      this.isGetSvg = false;
    },
    getIsConcluido(status) {
      return status ? 'Sim' : 'Não';
    },
  },
};
</script>
